import { createFileRoute, redirect } from "@tanstack/react-router";
import { InboxPage } from "../components/inbox/InboxPage";

/** Personal inbox, independent of the chat route and selected organization. */
export const Route = createFileRoute("/inbox")({
  beforeLoad: ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: InboxPage,
});
